'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ChatSubscriberList} from '../ChatSubscriberList';
import {ChatPanel} from '../ChatPanel';
import {I18nMessage} from '../../../components/I18nMessage';

export function ChatSubscriberPanelView(props) {
  return (
    <ChatPanel
      className={classNames("ChatSubscriberPanel", props.className)}
      headerLabel={<I18nMessage message="comments.subscribers.label" />}
      onClose={props.onClose}
      onHidePanel={props.onHidePanel}
    >
      <ChatSubscriberList
        init={props.init}
        className="ChatSubscriberPanel__list"
        parentId={props.parentId}
        useTypeHeaders={false}
        useSimple={true}
        useSelection={false}
      />
    </ChatPanel>
  );
}

ChatSubscriberPanelView.propTypes = {
  init: T.bool,
  className: T.string,
  parentId: T.string.isRequired,
};

ChatSubscriberPanelView.defaultProps = {
  init: true,
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/comments/components/ChatSubscriberPanel/ChatSubscriberPanelView.js